"use client";

import dynamic from "next/dynamic";

import Loading from "./loadingIndicator";

const BeemoApp = dynamic(() => import("../../src/BeemoApp"), {
  loading: () => <Loading />,
  ssr: false,
});

export function ClientOnly() {
  return <BeemoApp />;
}
